import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileWidgets = {
  index: async(props) => {
    const { default: WidgetsIndex } = await import('@/vue_widgets/geobooster/widgets/index.vue')
    createVueApp(WidgetsIndex, { props, sidebar })
  }

  // Phase 5: Widget Editor
  // edit: async(props) => { ... }
}
